import ReactDOM from 'react-dom';
import { CoreApp } from '@bubbletea/core';
import React from 'react';
import computedTheme from './theme';
import Content from './components/Content';
import customReducers from './features';
import data from './data/content.json';
import { IContent } from './types';

import 'swiper/css';
import 'swiper/css/pagination';

const appElement = document.getElementById(process.env.REACT_APP_NAME);
const renderMethod = process.env.NODE_ENV === 'production' ? ReactDOM.hydrate : ReactDOM.render;

renderMethod(
  <React.StrictMode>
    <CoreApp
      computedTheme={computedTheme}
      data={data as IContent[]}
      customReducers={customReducers}
      content={Content}
    />
  </React.StrictMode>,
  appElement
);
